import React from "react";
import { useTranslation } from "react-i18next";
import { useGetCartQuery } from "../../api/cartApi";
import Icon from "../../../../../common/components/Icon/Icon";

interface FirstPurchaseBannerProps {
  context?: "page" | "panel";
}

const FirstPurchaseBanner: React.FC<FirstPurchaseBannerProps> = ({
  context = "page",
}) => {
  const { t } = useTranslation();
  const { data: cart, isLoading } = useGetCartQuery();

  if (isLoading || !cart || !cart.firstPurchasePromotion) return null;

  const { isActive, isGuest, isUserEligible, percentage, promoText } =
    cart.firstPurchasePromotion;

  // If the feature is turned off globally, render nothing.
  if (!isActive) return null;

  // SCENARIO 1: User is a guest. Show the marketing prompt to log in.
  if (isGuest) {
    const loginUrl = window.commonVariables?.loginUrl || "/wp-login.php";
    return (
      <div
        className={`first-purchase-banner first-purchase-banner--${context} first-purchase-banner--guest`}
      >
        <Icon iconName="ticket-outlined" className="icon--stroke-thick" />
        <div className="first-purchase-banner__content">
          <span>{promoText}</span>{" "}
          <a href={loginUrl} className="first-purchase-banner__link">
            {t("firstPurchase.loginLink", "Login / Register")}
          </a>
        </div>
      </div>
    );
  }

  // SCENARIO 2: User is logged in AND eligible. Show success confirmation.
  if (isUserEligible) {
    return (
      <div
        className={`first-purchase-banner first-purchase-banner--${context} first-purchase-banner--eligible`}
      >
        <Icon iconName="check-circle" className="icon--filled" />
        <div className="first-purchase-banner__content">
          <span>
            {t("firstPurchase.successMessage", {
              percentage,
              defaultValue: `Congrats! Your %${percentage} first purchase discount has been automatically applied to your cart.`,
            })}
          </span>
        </div>
      </div>
    );
  }

  // SCENARIO 3: User is logged in but NOT eligible (already made a purchase).
  return null;
};

export default FirstPurchaseBanner;
